export const BREADCRUMBS_SEPARATOR = '>';
